import React from 'react';


const About = () => {
    return (
        <div>
            <h1>Contact Us </h1>
            <br />
            <br />
           <p>T-Travel Customer Relations</p> <br />
           <p>Albuquerque, NM 87176-7380</p> <br />
           <p>Please don't send payments to this address</p>

        </div>
    );
};

export default About;